import { render, staticRenderFns } from "./WorkEdit.vue?vue&type=template&id=fc1b6b16&scoped=true"
import script from "./WorkEdit.vue?vue&type=script&lang=js"
export * from "./WorkEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkEdit.vue?vue&type=style&index=0&id=fc1b6b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1b6b16",
  null
  
)

export default component.exports